import { AxiosClient } from '@/app/shared/services';

const state = {
    templates: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
    currentTemplate: {
        id: '',
        name: '',
        json: {
            name: 'root',
            ivrs: []
        },
        account_mailer: {
            name: '',
            id: null,
        },
    },

    records: {
        data: [
        ],
        isLoading: false,
    },

    phones: {
        data: [
        ],
        isLoading: false,
    },
};

const getters = {
    TEMPLATES_IS_LOADING: state => state.templates.isLoading,
    TEMPLATES_LOADING_SUCCESS: state => state.templates.isSuccess,
    CURRENT_TEMPLATE: state => state.currentTemplate,
    TEMPLATES: state => state.templates.data,

    RECORDS: state => state.records.data,
    RECORDS_IS_LOADING: state => state.records.isLoading,


    PHONES: state => state.phones.data,
    PHONES_IS_LOADING: state => state.phones.isLoading,
};

const mutations = {
    SET_TEMPLATES: (state, templates) => {
        state.templates.data = templates;
    },
    SET_TEMPLATES_LOADING: (state, isLoading) => {
        state.templates.isLoading = isLoading;
    },
    SET_TEMPLATES_LOADING_SUCCESS: (state, isSuccess) => {
        state.templates.isSuccess = isSuccess;
    },
    SET_CURRENT_TEMPLATE: (state, template) => {
        state.currentTemplate = template;
    },

    SET_RECORDS: (state, records) => {
        state.records.data = records;
    },
    SET_RECORDS_LOADING: (state, isLoading) => {
        state.records.isLoading = isLoading;
    },

    SET_PHONES: (state, phones) => {
        state.phones.data = phones;
    },
    SET_PHONES_LOADING: (state, isLoading) => {
        state.phones.isLoading = isLoading;
    },
};

const actions = {
    GET_TEMPLATES: (context, params) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/call_template/get', {params})
                .then((data) => {
                    context.commit('SET_TEMPLATES', data.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },
    CREATE_TEMPLATE: (context, params) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/call_template/create', params)
                .then((data) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },
    UPDATE_TEMPLATE: (context, params) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/call_template/update', params)
                .then((data) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },
    GET_TEMPLATE_BY_ID: (context, templateId) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/call_template/get/${templateId}`)
                .then((data) => {
                    context.commit('SET_CURRENT_TEMPLATE', data.data);
                    resolve(data.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },
    DELETE_TEMPLATE: (context, templateId) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/call_template/delete/${templateId}`)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },

    GET_RECORDS: (context, params) => {
        context.commit('SET_RECORDS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/records/get', {params})
                .then((data) => {
                    context.commit('SET_RECORDS', data.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_RECORDS_LOADING', false);
                });
        });
    },
    CREATE_RECORD: (context, record) => {
        context.commit('SET_RECORDS_LOADING', true);
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            for (const key in record) {
                if (record.hasOwnProperty(key)) {
                    formData.append(key, record[key]);
                }
            }
            AxiosClient.post(`/records/create`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_RECORDS_LOADING', false);
                });
        });
    },
    DELETE_RECORD: (context, recordId) => {
        context.commit('SET_RECORDS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/records/delete/${recordId}`)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_RECORDS_LOADING', false);
                });
        });
    },

    CREATE_MESSAGE_TEMPLATE_MODAL: (context, isOpen) => {
        context.commit("SET_CREATE_MESSAGE_TEMPLATE_MODAL_IS_OPENED", isOpen);
    },

    UPDATE_AUDIO_LIST: (context) => {
        context.commit('SET_RECORDS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/records/update_records')
                .then((response) => {
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_RECORDS_LOADING', false);
                });
        });
    },

    UPDATE_CALL_TEMPLATES: (context) => {
        context.commit('SET_TEMPLATES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/call_template/update_templates')
                .then((response) => {
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_TEMPLATES_LOADING', false);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
